/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { CommodityPo } from '@/po/commodity';
import { Vue } from 'vue/types/vue';

import { cache } from '@/shared/utils/Cache';
import { ubtPageButton, ubtModuleExposeNew } from '@/shared/utils/ubt';
import { openInnerPage, openThirdPage, setStatusBar } from '@/api/native/utils';
import {
  loanUrl, rechargeH5Url, localPrerenderUrl,
  newLoanMarketUrl,
  androidSpecialDownloadUrl, financeH5WebUrl, harmonyAppDownloadUrl,
} from '@/constant';
import { SessionEnum } from '@/enums/session';
import router from '@/router';
import store from '@/store';
import { iOSRedirect } from '@/shared/utils/iOSRedirect';
import { landData } from '@/shared/utils/landData';
import { changeTabbarShowStatus } from '@/api/native/container';
import { RouterV2Enum, RouterV3Enum } from '@/router/router-names';
import { Toast } from '@hb/coffee';
import { getWisdomConfig } from '@/shared/wisdom';
import { SwitchTypeEnum } from '@/enums/contract-type';
import { NewVersionEnum } from '@/enums/newVersionRoute';
import { LocalEnum } from '@/enums/local';
import platform from '../platform';
import { local, session } from '../storage';
import { startMonitorPageVisibility } from '../pageControl';
import { mapRouteByRepaymentVersion } from '../repaymentVersion';
import { interceptWechatScheme } from '../wechatSchemeInterceptor';

const HBridge = import('@hb/hbridge');

/** 是否跳转Loan项目（新项目）页面时不使用预渲染html */
let isNoUsePreRenderInJumpLoanPage = false;

export const initIsNoUsePreRenderInJumpLoanPage = async (): Promise<void> => {
  try {
    const result = await getWisdomConfig<boolean>('isNoUsePreRenderInJumpLoanPage');

    isNoUsePreRenderInJumpLoanPage = typeof result === 'boolean' ? result : false;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
};

/* 延迟初始化，避免影响页面主流程性能 */
setTimeout(initIsNoUsePreRenderInJumpLoanPage, 1000);

export const openWithNewWebview = (url: string): boolean => {
  const fromPath = window.location.href;
  if ((fromPath.includes(RouterV2Enum.home)
      || fromPath.includes(RouterV2Enum.taglessHome)
      || fromPath.includes(RouterV2Enum.qualityHomePage)
      || fromPath.includes(RouterV3Enum.home))
      && store.state.base.isHybridAppMode
      && !(url.includes(RouterV2Enum.home)
      || url.includes(RouterV2Enum.taglessHome)
      || url.includes(RouterV2Enum.qualityHomePage)
      || url.includes(RouterV3Enum.home))
  ) {
    return true;
  }
  return false;
};
export const jumpTo = (url: string): void => {
  openThirdPage(url);
};

export const jumpToLocal = (uri: string, isOpenH5Webview?: boolean): void => {
  const baseUrl = `${window.location.origin + window.location.pathname}#`;
  const lastUrl = `${baseUrl}${uri}${uri.includes('?') ? '&' : '?'}source=${String(cache.get('source') || 'default')}`;

  if (isOpenH5Webview) {
    window.open(lastUrl);
  } else {
    openThirdPage(lastUrl);
  }
};

export const jumpToContract = (contractName: string): void => {
  const baseUrl = `${window.location.origin + window.location.pathname.replace('index.html', '')
  }contract/`;

  openThirdPage(`${baseUrl}${contractName}.html`);
};

export const jumpToContractList = (contractList: any[]): void => {
  const contractListUrl = `${window.location.origin + window.location.pathname}#${RouterV2Enum.legalConstract}?useSessionCached=true`;

  local.set(LocalEnum.readContractList, contractList);
  openThirdPage(contractListUrl);
};

export const jumpToCommodity = async (
  that: Vue,
  commodity: CommodityPo.Info,
): Promise<void> => {
  ubtPageButton(that, 'APP_借款_产品第三方',
    '产品',
    commodity.commodityId);

  const switchConfig = await getWisdomConfig<{ isOpen: SwitchTypeEnum }>('interceptWechatSchemeSwitch');

  if (switchConfig.isOpen === SwitchTypeEnum.ON) {
    const tips = '维护中 看看其他产品吧';
    // 拦截微信Scheme
    if (interceptWechatScheme(commodity.thirdH5Url)) {
      ubtModuleExposeNew(that, 'finance_loan_creditMarket_forbid_wechat_series',
        {
          productId: commodity.commodityId,
          link: commodity.thirdH5Url,
          isNative: 0,
        });
      Toast(tips);
      return;
    }

    /** 针对贷超外跳场景，做WebView内部拦截处理，需要传指定参数。
   * 技术方案地址：https://hellobike.yuque.com/pangu-4gxeo/elsqrp/gg9yzipt7uh1p08u
   * 需求wiki：http://wiki.hellobike.com/pages/viewpage.action?pageId=402521826
   * 埋点：https://target.hellobike.cn/#/needs/buryingNeeds/detail?requirementId=15995
   */

    if (platform.isHelloApp) {
      (await HBridge).Native.callNative({
        classMap: 'Third',
        method: 'openThirdWeb',
        params: {
          url: commodity.thirdH5Url,
          disableExternalLinks: 'true',
          disableExternalTips: tips,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          pageId: that.$route.meta.pageId,
          moduleId: 'finance_loan_creditMarket_forbid_wechat_series',
          categoryId: 'finance',
          productId: String(commodity.commodityId),
        },
      });
    } else {
      window.location.href = commodity.thirdH5Url;
    }
  } else {
    openThirdPage(commodity.thirdH5Url);
  }
};

/**
 * Andriod打开预渲染页面异常，临时解决方案：先不使用预渲染html，使用index.html进行跳转
 */
const noUsePrerenderRouterList = [
  NewVersionEnum.RepayBills,
  NewVersionEnum.RepaymentBills,
  NewVersionEnum.RepayPlans,
  NewVersionEnum.RepaymentPlan,
  NewVersionEnum.Repay,
  NewVersionEnum.RepayRecords,
  NewVersionEnum.CREDIT_RESULT,
  NewVersionEnum.HALF_PROCESS_FAILED,
];

/** 跳转臻有钱新项目地址 */
export const jumpToNewVersion = async (
  /** 页面路由 */
  urlOrRouter: string,
  /** 是否relpace方式跳转链接 */
  replace: boolean,
  /** 当前路由上需要拼接的路径 */
  query?: string,
): Promise<void> => {
  if (platform.isHelloApp && (platform.isAndroid || platform.isHarmony)) {
    setStatusBar({ isShowStatusBar: true });
  }

  // 跳转新项目之前 移除本地绑卡相关缓存的信息
  session.remove(SessionEnum.toBindCard);

  // 根据还款流程版本映射路由
  const finalUrlOrRouter = await mapRouteByRepaymentVersion(urlOrRouter);

  let url;

  const isNoUsePr = (platform.isAndroid
    && noUsePrerenderRouterList.includes(finalUrlOrRouter as NewVersionEnum)
    && isNoUsePreRenderInJumpLoanPage);

  if (finalUrlOrRouter.startsWith('http')) {
    /** 兼容是完整链接的场景 */
    url = `${finalUrlOrRouter}${finalUrlOrRouter.includes('?') ? '&' : '?'}${query || ''}`;
  } else {
    url = `${isNoUsePr ? loanUrl.replace('pr_index_', '') : loanUrl}${isNoUsePr ? 'index' : finalUrlOrRouter}.html#/${finalUrlOrRouter}`;
    url += `${query ? `?${query}&` : '?'}hiddenNavigationBar=1&fromAppFinanceH5Web=true`;
  }

  const themeType = store.state.base.pageThemeType;
  /** 若主题类型存在，则传递主题至新项目 */
  if (themeType) {
    url = `${url}${url.includes('?') ? '&' : '?'}themeType=${themeType}`;
  }

  const isAppOrAlimini = platform.isHelloApp || platform.isAlipayMini;


  // 跳转方法里开启监听，避免影响其他逻辑
  if ((platform.isAndroid || platform.isHarmony) && isAppOrAlimini) {
    document.addEventListener('visibilitychange', () => {
      try {
        // 监听webview可见事件，回退时回到某个页面
        startMonitorPageVisibility();
      } catch (e) {
        // 异常捕获，不阻塞流程
      }
    });
  }

  /** 跳转新项目之前 隐藏 tabbar */
  changeTabbarShowStatus(false);


  if (replace) {
    // 因为IOS白屏问题，跳转方案差异化处理
    if ((platform.isAndroid || platform.isHarmony) && isAppOrAlimini) {
      await openInnerPage(url);
      store.state.base.backByJumpToNew = true;
      // replace方式，需要将路由回退回上一个路径栈
      router.go(-1);
    } else {
      if (openWithNewWebview(url)) {
        openInnerPage(url);
      } else {
        if (store.state.base.isHybridAppMode) {
          url = `${url}${url.includes('?') ? '&' : '?'}hybridAppMode=1`;
        }

        if (platform.isWechatMini) {
          /** 小程序 window.location.replace 未删除当前访问记录，location.href 可以符合效果 */
          window.location.href = url;
        } else {
          window.location.replace(url);
        }
      }
    }
  } else {
    if ((platform.isAndroid || platform.isHarmony) && isAppOrAlimini) {
      openInnerPage(url);
    } else {
      if (openWithNewWebview(url)) {
        openInnerPage(url);
      } else {
        if (store.state.base.isHybridAppMode) {
          url = `${url}${url.includes('?') ? '&' : '?'}hybridAppMode=1`;
        }
        window.location.href = url;
      }
    }
  }
};

/** 营销场景使用的跳转方法 */
export const jumpToUrl = (vueInstance: Vue, link: string): void => {
  if (!/^http(s?):\/\//.test(link)) {
    vueInstance.$router.push({
      path: link,
    });
  } else if (link.includes('AppFinanceH5Web')) {
    const newLink = link.split('#')[1];
    vueInstance.$router.push({
      path: newLink,
    });
  } else {
    openThirdPage(link);
  }
};

/** 跳转哈臻快h5地址 */
export const jumpToRechargeH5 = (
  /** 页面路由 */
  routerName: string,
  /** 当前路由上需要拼接的路径 */
  query?: string,
  /** 是否relpace方式跳转链接 */
  replace = false,
): void => {
  const url = `${rechargeH5Url}${routerName}.html#/${routerName}${query ? `?${query}` : ''}`;

  /** 跳转新项目之前 隐藏 tabbar */
  changeTabbarShowStatus(false);

  if (replace) {
    if (openWithNewWebview(url)) {
      openThirdPage(url);
    } else {
      window.location.replace(url);
    }
  } else {
    openThirdPage(url);
  }
};

/** 跳转贷超新主体h5地址 */
export const jumpToNewLoanMarketH5 = async (
  /** 页面地址 */
  urlOrRouter: string,
  /** 是否relpace方式跳转链接 */
  replace = false,
  /** 当前路由上需要拼接的路径 */
  query?: string,
): Promise<void> => {
  if (platform.isHelloApp && (platform.isAndroid || platform.isHarmony)) {
    setStatusBar({ isShowStatusBar: true });
  }

  // 跳转新项目之前 移除本地绑卡相关缓存的信息
  session.remove(SessionEnum.toBindCard);

  let url;

  if (urlOrRouter.startsWith('http')) {
    /** 兼容是完整链接的场景 */
    url = `${urlOrRouter}${urlOrRouter.includes('?') ? '&' : '?'}${query || ''}`;
  } else {
    url = `${newLoanMarketUrl}${urlOrRouter}.html#/${urlOrRouter}`;
    url += `${query ? `?${query}&` : '?'}hiddenNavigationBar=1&fromAppFinanceH5Web=true`;
  }

  const themeType = store.state.base.pageThemeType;
  /** 若主题类型存在，则传递主题至新项目 */
  if (themeType) {
    url = `${url}${url.includes('?') ? '&' : '?'}themeType=${themeType}`;
  }

  const isAppOrAlimini = platform.isHelloApp || platform.isAlipayMini;


  // 跳转方法里开启监听，避免影响其他逻辑
  if ((platform.isAndroid || platform.isHarmony) && isAppOrAlimini) {
    document.addEventListener('visibilitychange', () => {
      try {
        // 监听webview可见事件，回退时回到某个页面
        startMonitorPageVisibility();
      } catch (e) {
        // 异常捕获，不阻塞流程
      }
    });
  }

  /** 跳转新项目之前 隐藏 tabbar */
  changeTabbarShowStatus(false);

  if (replace) {
    // 因为IOS白屏问题，跳转方案差异化处理
    if ((platform.isAndroid || platform.isHarmony) && isAppOrAlimini) {
      await openThirdPage(url);
      store.state.base.backByJumpToNew = true;
      // replace方式，需要将路由回退回上一个路径栈
      router.go(-1);
    } else {
      if (openWithNewWebview(url)) {
        openThirdPage(url);
      } else {
        if (store.state.base.isHybridAppMode) {
          url = `${url}${url.includes('?') ? '&' : '?'}hybridAppMode=1`;
        }
        window.location.replace(url);
      }
    }
  } else {
    if ((platform.isAndroid || platform.isHarmony) && isAppOrAlimini) {
      openThirdPage(url);
    } else {
      if (openWithNewWebview(url)) {
        openThirdPage(url);
      } else {
        if (store.state.base.isHybridAppMode) {
          url = `${url}${url.includes('?') ? '&' : '?'}hybridAppMode=1`;
        }
        window.location.href = url;
      }
    }
  }
};

/** 跳转fianceH5本地预渲染页面 */
export const jumpToLocalPreRenderPage = (
  /** 页面路由，如：/v2/guide-download */
  routerName: string,
  /** 当前路由上需要拼接的路径 */
  query?: string,
  /** 是否使用新webview打开 */
  useNewWebview = false,
  /** 是否relpace方式跳转链接 */
  replace = false,
): void => {
  const url = `${localPrerenderUrl}${routerName.replace(/\//g, '_')}.html#${routerName}${query ? `?${query}` : ''}`;

  if (replace) {
    if (openWithNewWebview(url)) {
      openThirdPage(url);
    } else {
      let newUrl = url;
      if (store.state.base.isHybridAppMode) {
        newUrl = `${newUrl}${newUrl.includes('?') ? '&' : '?'}hybridAppMode=1`;
      }
      window.location.replace(newUrl);
    }
  } else {
    openThirdPage(url, useNewWebview);
  }
};

/** 跳转下载哈啰app */
export const jumpToRedirectHelloApp = ():void => {
  if (platform.isIOS) {
    window.location.href = `hellobike://hellobike.com/openWeb?webUrl=${financeH5WebUrl}#/v2/home?hiddenNavigationBar=1&source=${landData.getSouce()}`;
    iOSRedirect();
  } else if (platform.isAndroid) {
    window.location.href = androidSpecialDownloadUrl;
  } else if (platform.isHarmony) {
    window.location.href = harmonyAppDownloadUrl;
  }
};

/** 从钱包tab首页跳转，打开二级页面 */
export const jumpFromWalletTab = (
  /** 跳转的页面路径 */
  next: any,
  /** */
  to: any,
  /**  */
  from: any,
): void => {
  if (to.path === from.path) {
    next();
  } else {
    if (openWithNewWebview(to.fullPath)) {
      const url = `${window.location.origin}${window.location.pathname}#${to.fullPath}${to.fullPath.includes('?') ? '&' : '?'}source=${landData.getSouce()}`;
      openInnerPage(url);
    } else {
      next();
    }
  }
};

/** 离开臻有钱，回到钱包Tab */
export const jumpToWalletTab = () => {
  window.location.href = 'hellobike://hellobike.com/wallet?index=0';
};
